<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Button, Icon, Input, Label } from "sveltestrap";
  import type { Pedestrian } from "../../../Model/Pedestrian";
    import type { Third } from "../../../Model/Third";
    import { thirdsService } from "../../../services";
  import { dateInputFormatter, dateTimeInputFormatter } from "../../../services/Functions";
  import AddThirdList from "../../AddThirdList.svelte";
    import PhotoUnique from "../../PhotoUnique.svelte";
  import ThirdNameInput from "../../ThirdNameInput.svelte";

  const dispatch = createEventDispatcher();

  export let pedestrian: Pedestrian;

  let changeThird = false;
  let third: Third;

  let date: string;
  let time: string;

  $: loadData(pedestrian);

  async function changeThirdEvent(third){
    pedestrian.pedestrianThirId = third.id;
    changeThird = false;
    dispatch("changeThirdLIst", third);
  }

  async function loadData(complainant){

    third = await thirdsService.findOne(complainant.pedestrianThirId)

    if (complainant && complainant.dateCreated) {
      date = dateInputFormatter(new Date(complainant.dateCreated));
      time = dateTimeInputFormatter(new Date(complainant.dateCreated));
    }else{
      date = dateInputFormatter(new Date());
      time = dateTimeInputFormatter(new Date());
    }
  }

  function onHandleChange() {
    pedestrian.dateCreated = date + "T" + time + ":00.000Z";
  }

  async function saveThirdData(){
    if (!third.name) return;
    await thirdsService.saveThird(third)
  }

  function reloadPhoto(photoId){
    third.photo = photoId;
    saveThirdData();  
  }

  function removePhoto(){
    third.photo = null; 
    saveThirdData();  
  }

</script>

<div class="row">
  <div class="col-12 col-md-2 mt-2 mb-3">
    {#if third}
      <Label for="exampleEmail">Imagen</Label>
      <PhotoUnique contextId={third.id} bind:photoId={third.photo} on:removePhoto={(event) => removePhoto()} on:updatePhoto={(event) => reloadPhoto(event.detail)}/>
    {/if}
  </div>

  <div class="col-12 col-md-10 mt-2 mb-3">
    <div class="row">
      <div class="col-12 mb-3">
        <Label for="victim">Nombre</Label>
        <div class="input-group">
          <ThirdNameInput id={pedestrian.pedestrianThirId} />
          <button
            class="btn btn-secondary"
            type="button"
            id="complainantThirId"
            name="complainantThirId"
            on:click={() => {
              changeThird = true;
            }}><Icon name="plus" /></button>
        </div>
      </div>

      {#if changeThird}
        <div class="m-3 p-2 border rounded third-box-modal">
          <h5>Busqueda de Terceros</h5>
          <AddThirdList on:changeThird={(event) => changeThirdEvent(event.detail)} />
        </div>
      {/if}

      <div class="col-12 col-md-3 mb-3">
        <Label for="mark">Fecha Manif.</Label>
        <Input
          type="date"
          on:change={onHandleChange}
          bind:value={date}
        />
      </div>
      <div class="col-12 col-md-3 mb-3">
        <Label for="time">Hora Manif.</Label>
        <Input
          type="time"
          id="time"
          on:change={onHandleChange}
          bind:value={time}
        />
      </div>

      <div class="col-12 mt-2">
        <Label for="mark">Presenta</Label>
        <Input
          type="textarea"
          rows={6}
          bind:value={pedestrian.present}
        />
      </div>
      <div class="col-12 mt-2">
        <Label for="mark">Manifectación</Label>
        <Input
          type="textarea"
          rows={6}
          bind:value={pedestrian.manifestation}
        />
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .third-box-modal{
    max-width: 96% !important;
  }
</style>